// React Thirty Party Library
import { Form, Col, DatePicker, 
    TreeSelect, 
    Select } from "antd";
import { useSelector } from "react-redux";

// Constants Library

// Components Library

// Redux Library
import { REDUX as REDUX_UTIL, 
    // TIME 
} from "../../../../services/util";

// Styles Library
 
const { reduxStoreWrapper } = REDUX_UTIL
// const { todayStart, todayEnd } = TIME

const optionsType = [
    { label: 'Daily Performance', value: 'performance' },
    { label: 'Enhanced Driver Scoring', value: 'driverScoring' },
    { label: 'Incident', value: 'incident' },
    { label: 'History Pre-Trip', value: 'pretrip' },

    // { label: 'Attendance Log', value: 'attendance' },
  ]

const treeDRVData = (drv) => ([{
    title: 'All',
    key: 'All',
    value: 'All',
    children: Object.values(drv).map((v) => ({
        title: v.name,  
        key: `${v.name}@${v.drvid}`, 
        value: `${v.name}@${v.drvid}`, 
        // value: v.drvid,  
    }))
}])

const DriverSearchField = ({ form, handleTypeChange, selectedType }) => { 

    
    const drivers = useSelector(reduxStoreWrapper("drivers.byID"));

const driverOptions = selectedType === 'driverScoring' ? treeDRVData(drivers) : Object.values(drivers).map(u => ({ label: u.name, value: `${u.drvid}@${u.name}` })).sort((a, b) => a.label.localeCompare(b.label))

  return (
    <>
        {/* <Col className = "formField report">
            <Form.Item name="drvids" rules={[{ required: true }]}>
                <span className = "formFieldLabel">Driver: </span>
                <TreeSelect
                    treeData={driverOptions}
                    treeCheckable
                    showCheckedStrategy={TreeSelect.SHOW_PARENT}
                    placeholder = {Object.keys(drivers).length ? 'Select Drivers' : "No Drivers Found"}
                    disabled = {!Object.keys(drivers).length}
                    style={{ width: '190px', maxHeight: 30, overflowY: 'auto', height: 30 }}
                    onChange={(value) => {
                        form.setFieldsValue({ drvids: value?.map(v => v?.split('_')[1] || v) })
                    }}
                />
            </Form.Item>
        </Col>  */}

        <Col className = "formField">
            <Form.Item name="drvids" rules={[{ required: true }]}>
                <span className = "formFieldLabel">Driver: </span>
                {
                    (selectedType === 'driverScoring')
                    &&
                    <TreeSelect
                        treeData={driverOptions}
                        treeCheckable
                        showCheckedStrategy={TreeSelect.SHOW_PARENT}
                        placeholder = {Object.keys(drivers).length ? 'Select Drivers' : "No Drivers Found"}
                        // disabled = {!Object.keys(drivers).length}
                        style={{ width: '190px', maxHeight: 30, overflowY: 'auto', height: 30 }}
                        onChange={(value) => {
                            const val = value?.includes('All') ? (Object.values(drivers).map(v => v.drvid)) : value?.map(v => v?.split('@')[1])

                            form.setFieldsValue({ drvids: val })
                        }}
                    />
                    ||
                    <Select 
                        className="customSelect" 
                        style={{ width: '180px'}}
                        showSearch
                        options={driverOptions} 
                        onChange={(value) => {
                            const val = value.split('@')[0]
                            form.setFieldsValue({ drvids: [val] })
                        }}
                    />
                }
            </Form.Item>
        </Col>

        <Col className = "formField">
        {
            (selectedType === 'driverScoring')
            &&
            <Form.Item name="timeframe" rules={[{ required: true }]}>
                <span className = "formFieldLabel">Review Month: </span>
                <DatePicker
                    picker="month"
                    onChange={e => form.setFieldsValue({ month: e.format('YYYY-MM') })} 
                />
            </Form.Item>
            ||
            <Form.Item name="timeframe" rules={[{ required: true }]}>
                <span className = "formFieldLabel">Timeframe: </span>
                <DatePicker.RangePicker 
                    showTime
                    format="YYYY-MM-DD HH:mm"
                    onChange={e => form.setFieldsValue({ timeframe: e })} 
                />
            </Form.Item>
        }
        </Col>

        <Col className = "formField">
            <Form.Item name="type" rules={[{ required: true }]}>
                <span className = "formFieldLabel">Report: </span>
                <Select className="customSelect" onChange={handleTypeChange} options={optionsType} style={{ width: '180px'}}/>
            </Form.Item>
        </Col>
    </>
  );
};

export default DriverSearchField;